






























import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import Avatar from '@/components/Avatar.vue'
import { IAdminTask } from '@zunta/configurations'
import DataTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ScrollView from '@/components/ScrollView.vue'

@Component({
  components: {
    Avatar,
    Modal,
    DataTimeLabel,
    ScrollView
  },
  props: {
    tasks: {
      type: Array,
      required: true
    }
  }
})
export default class TaskDetailsListModal extends Vue {
  getTaskLabel (task: IAdminTask) {
    // @ts-ignore
    switch (task.state) {
      case 'infuture':
        return 'In Future'
      case 'week':
        return 'Last Week'
      case 'twoWeeks':
        return '2 Weeks'
      case 'old':
        return 'More than a month'
      default:
        return 'Unknown'
    }
  }

  getTaskClasses (task: IAdminTask) {
    return {
      // @ts-ignore
      [task.state]: true
    }
  }
}
